import { render, staticRenderFns } from "./WBtnDeactivate.vue?vue&type=template&id=3f6fd1ff&scoped=true&"
import script from "./WBtnDeactivate.vue?vue&type=script&lang=js&"
export * from "./WBtnDeactivate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6fd1ff",
  null
  
)

export default component.exports